export const SET_API_ME = 'SET_API_ME';
export const SET_APP_SETTINGS = 'SET_APP_SETTINGS';